export default __webpack_public_path__ + "static/media/ravenClosedFIT.6cfa4d43.png";